/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exchange_Shop_TitleInputs */

const en_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stamp Exchange Shop`)
};

const ar_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متجر استبدال الطوابع`)
};

const de_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stempel-Einlöse-Shop`)
};

const es_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda de canje de sellos`)
};

const fr_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boutique d'échange de timbres`)
};

const it_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Negozio di scambio timbri`)
};

const ja_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタンプ交換ショップ`)
};

const ko_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스탬프 교환 상점`)
};

const pt_br_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loja de troca de selos`)
};

const ru_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин обмена штампов`)
};

const th_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ร้านค้าแลกเปลี่ยนแสตมป์`)
};

const tr_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pul Takas Mağazası`)
};

const zh_cn_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花兑换商店`)
};

const zh_tw_exchange_shop_title = /** @type {(inputs: Exchange_Shop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印花兌換商店`)
};

/**
* | output |
* | --- |
* | "Stamp Exchange Shop" |
*
* @param {Exchange_Shop_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const exchange_shop_title = /** @type {((inputs?: Exchange_Shop_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exchange_Shop_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exchange_shop_title(inputs)
	if (locale === "ar") return ar_exchange_shop_title(inputs)
	if (locale === "de") return de_exchange_shop_title(inputs)
	if (locale === "es") return es_exchange_shop_title(inputs)
	if (locale === "fr") return fr_exchange_shop_title(inputs)
	if (locale === "it") return it_exchange_shop_title(inputs)
	if (locale === "ja") return ja_exchange_shop_title(inputs)
	if (locale === "ko") return ko_exchange_shop_title(inputs)
	if (locale === "pt_br") return pt_br_exchange_shop_title(inputs)
	if (locale === "ru") return ru_exchange_shop_title(inputs)
	if (locale === "th") return th_exchange_shop_title(inputs)
	if (locale === "tr") return tr_exchange_shop_title(inputs)
	if (locale === "zh_cn") return zh_cn_exchange_shop_title(inputs)
	return zh_tw_exchange_shop_title(inputs)
});